import { QueryKey } from '@tanstack/react-query';
import { Severity } from '@unistocks/proxy/axios-client';
import { notificationsGetListQueryKey } from '@unistocks/proxy/axios-client/NotificationsQuery';

type NotificationToastType = 'info' | 'success' | 'warning' | 'error';

export const severityToNotificationType: Record<Severity, NotificationToastType> = {
  [Severity.Info]: 'info',
  [Severity.Success]: 'success',
  [Severity.Warning]: 'warning',
  [Severity.Error]: 'error'
};

export const NOTIFICATIONS_LIST_QUERY_KEY: QueryKey = [
  ...notificationsGetListQueryKey(undefined, undefined),
  'infinite'
];
